import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

interface RotatingPlaceholderProps {
    items: Array<string>
    hidden: boolean
    interval?: number
    className?: string
    onIndexChange?: (index: number) => void
}

// Animated stand-in for an input placeholder: each example rises into place, then the next one replaces it.
export const RotatingPlaceholder: FC<RotatingPlaceholderProps> = ({
    items,
    hidden,
    interval = 3200,
    className,
    onIndexChange
}): ReactNode => {
    const [index, setIndex] = useState(0)

    useEffect(() => {
        if (hidden) return

        const timer = window.setInterval(() => {
            setIndex(previous => (previous + 1) % items.length)
        }, interval)

        return () => window.clearInterval(timer)
    }, [hidden, interval, items.length])

    useEffect(() => {
        onIndexChange?.(index)
    }, [index, onIndexChange])

    if (hidden) return null

    return (
        <span aria-hidden='true' className={cn('pointer-events-none absolute overflow-hidden text-[#9a9aa4]', className)}>
            <span key={index} className='fc-placeholder-in block'>
                {items[index]}
            </span>
        </span>
    )
}
